<template>
  <div>
    <xolas-table
      :title="title"
      :url="'/candidates' + (this.siteId ? '/site/' + this.siteId : '') + (this.clientId ? '/client/' + this.clientId : '')"
      :table-ref="tableRef"
      :fields="fields"
      :options="options"
      :show-search="false"
      sort-field="site_id,client_id,optionNo|desc"
      show-refresh
      :search-placeholder="searchPlaceholder"
      :layer-component="'candidate'"
      :layer-args="{ id: 'id' }"
      @totalChanged="totalOptions">

      <!-- Add-Option button — XolasTable has no add-action prop (vuetable-2 legacy);
           render the action in the shared #actions slot like the other tables. -->
      <template v-if="!readOnly" #actions>
        <option-action :site-data="siteData" :total-options="currentNo" />
      </template>

      <template #option="props">

            <!-- eslint-disable-next-line vue/no-v-html -- formatter output, numeric → <b><sup> ordinal markup -->
            <span v-html="addSuffix(props.rowData.optionNo)" />
            &nbsp;{{props.rowData.title ? props.rowData.title + (props.rowData.clientRef ? ' | Ref:' + props.rowData.clientRef : '') : props.rowData.clientRef}}</b>

            <span v-if="props.rowData.surveyDate">&nbsp;Survey Date: {{formatDate(props.rowData.surveyDate)}}</span>
            <span v-if="props.rowData.landType">&nbsp;|&nbsp;Land Type: <b>{{props.rowData.landType}}</b></span>
            <span v-if="props.rowData.classificationType">&nbsp;|&nbsp;Classification Type: <b>{{props.rowData.classificationType}}</b></span>

      </template>


      <template #details="props">
        <span label="Structure Type" v-if="props.rowData.structure"><i class="fa fa-broadcast-tower">&nbsp;</i>{{props.rowData.structure.name}}&nbsp;<b v-if="props.rowData.structureHeight">{{props.rowData.structureHeight}}m.</b>&nbsp;</span>
        <span v-if="props.rowData.antennaHeight">Ant. <i class="fa fa-arrows-alt-v"></i> <b>{{props.rowData.antennaHeight}}m</b></span>
      </template>


      <template #distance="props">

          <el-tooltip v-if="props.rowData.distanceFromNominal" content="Distance from Nominal"  placement="left">
             <span> <i class="fa fa-bullseye"></i> <b>{{props.rowData.distanceFromNominal}}m</b></span>
          </el-tooltip>

          <el-tooltip v-if="props.rowData.distanceAccessRoad" content="Distance to Access Road" placement="top">
             <span>&nbsp;|&nbsp;<i class="fa fa-road"></i> <b>{{props.rowData.distanceAccessRoad}}m</b></span>
          </el-tooltip>

          <el-tooltip v-if="props.rowData.distanceNearestBuilding" content="Distance to Nearest Building">
             <span>&nbsp;|&nbsp;<i class="fa fa-home"></i> <b>{{props.rowData.distanceNearestBuilding}}m</b></span>
          </el-tooltip>

          <el-tooltip v-if="props.rowData.distanceNearestPower" content="Distance to Nearest Commerical Power" placement="right">
            <span>&nbsp;|&nbsp;<i class="fa fa-plug"></i> <b>{{props.rowData.distanceNearestPower}}m</b></span>
          </el-tooltip>

      </template>


      <template #delete="props">
        <el-button v-if="isTelco() || isManager('project|property|finance|admin|management')" type="danger" circle icon="fa fa-trash" size="mini" @click="deleteOption(props.rowData)" />
      </template>

    </xolas-table>
    <center class="text-muted">Total: {{currentNo}}</center>

    </div>
</template>


<script>

import SiteMixins from '@/mixins/SiteMixins'

import OptionAction from '@/components/actions/OptionAction'
import XolasTable from '@/components/atoms/tables/XolasTable'

export default {
    mixins: [SiteMixins],

    components: {
      XolasTable,
      OptionAction
    },

    props: {

      siteData: {
        type: Object,
        required: true
      },

      siteId: {
        type: Number,
        default: null
      },

      sharerId: {
        type: Number,
        default: null
      },

      title: {
        type: String,
        default: 'Options'
      },

      noAdd: {
        type: Boolean,
        default: false
      },

      hideTop: {
        type: Boolean,
        default: true
      },

      showSearch: {
        type: Boolean,
        default: true
      },

      showRefresh: {
        type: Boolean,
        default: true
      },

      searchPlaceholder: {
        type: String,
        default: 'Client Ref, Land Type, Station Type...'

      },

      readOnly: {
        type: Boolean,
        default: false
      }


    },


    methods: {

      deleteOption (row) {
        this.deleteItem(this, row.id, '/candidate', this.addSuffix(row.optionNo) + 'Option [' + row.site.siteName + ']', null, true, this.tableRef)
      },

      totalOptions (no) {
        this.currentNo = no
      }

    },


    data () {

      return {
        tableRef: 'siteCandidatesTable',

        clientId: this.isTelco() ? Number(this.org().id) : this.sharerId,
        currentNo: this.siteData.count ? this.siteData.count : 0,

        options: {
          siteData: this.siteData
        },

        // Per-column min-widths in the legacy vuetable's content ratios (Option is
        // the dominant column; delete is just the trash button) so el-table flexes
        // them to fill the table instead of distributing every column equally. Kept
        // proportional and summing under the table width so the columns fill without
        // a horizontal scrollbar. Client Status is wide enough to keep "Approved" on
        // one line — XOL-231.
        fields: [
          {
            name: 'clientStatus',
            title: 'Client Status',
            callback: this.formatStatus,
            minWidth: '110'
          },
          {
            name: '__slot:option',
            title: 'Option',
            minWidth: '300'
          },
          {
            name: '__slot:details',
            titleClass: 'hidden-md-and-down',
            dataClass: 'hidden-md-and-down',
            minWidth: '186'
          },
          {
            name: '__slot:distance',
            titleClass: 'hidden-sm-and-down',
            dataClass: 'hidden-sm-and-down',
            minWidth: '184'
          },
          {
            name: '__slot:delete',
            titleClass: 'hidden-md-and-down',
            dataClass: 'hidden-md-and-down',
            width: '50'
          }
        ]

      }

  },  // data


  mounted () {

    if (!this.telcoId && this.isTelco()) {
      this.telcoId = Number(this.org().id)
    }

  }

}

</script>
